import { render, staticRenderFns } from "./PlayPauseButton.vue?vue&type=template&id=321f85e5&"
import script from "./PlayPauseButton.vue?vue&type=script&lang=ts&"
export * from "./PlayPauseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports